/** @jsx jsx */

import {
  SkeletonText,
  Table,
  TableBody,
  TableHead,
  TableHeadHeading,
  TableRow,
  TableTd,
  TableTh,
  Text,
} from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  hiddenBottomBorder: css`
    border-bottom-style: none !important;
  `,
  initialTextAlignment: css`
    text-align: initial;
  `,
};

type Props = {
  isMoreInfoColumnVisible: boolean;
  isTitleVisible: boolean;
  isVersionColumnVisible: boolean;
};

function Loading({
  isMoreInfoColumnVisible,
  isTitleVisible,
  isVersionColumnVisible,
}: Props) {
  return (
    <Table>
      <TableHead>
        <TableRow>
          {isTitleVisible && (
            <th css={[Styles.hiddenBottomBorder, Styles.initialTextAlignment]}>
              <Text type="Title">History</Text>
            </th>
          )}
          <TableTh>
            <TableHeadHeading>Date</TableHeadHeading>
          </TableTh>
          <TableTh>
            <TableHeadHeading>Author</TableHeadHeading>
          </TableTh>
          <TableTh>
            <TableHeadHeading>Action</TableHeadHeading>
          </TableTh>
          {isVersionColumnVisible && (
            <TableTh>
              <TableHeadHeading>Action</TableHeadHeading>
            </TableTh>
          )}
          {isMoreInfoColumnVisible && (
            <TableTh>
              <TableHeadHeading>More Info</TableHeadHeading>
            </TableTh>
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {Array(3)
          .fill(0)
          .map((_, indexLog) => (
            <TableRow key={indexLog}>
              {isTitleVisible && (
                <td
                  css={indexLog === 2 ? undefined : Styles.hiddenBottomBorder}
                />
              )}
              <TableTd>
                <SkeletonText lines={1} />
              </TableTd>
              <TableTd>
                <SkeletonText lines={1} />
              </TableTd>
              <TableTd>
                <SkeletonText lines={1} />
              </TableTd>
              {isVersionColumnVisible && (
                <TableTd>
                  <SkeletonText lines={1} />
                </TableTd>
              )}
              {isMoreInfoColumnVisible && (
                <TableTd>
                  <SkeletonText lines={1} />
                </TableTd>
              )}
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}

export default Loading;
